import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  date: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    textAlign: 'center',
    fontSize: '14px',
    marginTop: '10px',
    marginBottom: '0px',
    '& > span': {
      fontWeight: 'bold',
    },
    '&.empty': {
      color: '#bcbcbc',
      fontWeight: 'normal',
    },
  },
  today: {
    borderRadius: '100%',
    width: '28px',
    height: '28px',
    backgroundColor: theme.colors.grey[250],
    color: theme.colors.primaryBlue[500],
    fontWeight: '800',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '-4px auto',
  },
  popover: {
    '& .MuiPopover-paper': {
      boxShadow: theme.shadows[1],
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.colors.grey[200],
      borderRadius: '12px',
      backgroundColor: theme.colors.white,
    },
  },
  list: {
    display: 'flex',
    width: '200px',
    padding: '8px',
    gap: '4px',
    height: '100%',
    flexDirection: 'column',
    borderRadius: '12px',
    maxHeight: '20vh',
    overflow: 'auto',
    '& > span': {
      fontSize: '11px',
    },
  },
}));

export default useStyles;